import {
  HomePage,
  TasksPage,
  ProfilePage,
  AppSolutionPage,
  WebSolutionPage,
  FAQPage,
  PlansPage,
} from "./pages";
import { withNavigationWatcher } from "./contexts/navigation";

const routes = [
  {
    path: "/tasks",
    element: TasksPage,
  },
  {
    path: "/profile",
    element: ProfilePage,
  },
  {
    path: "/home",
    element: HomePage,
  },
  {
    path: "/app-info",
    element: AppSolutionPage,
  },
  {
    path: "/web-info",
    element: WebSolutionPage,
  },
  {
    path: "/faq",
    element: FAQPage,
  },
  {
    path: "/plans",
    element: PlansPage,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
